// extracted by mini-css-extract-plugin
module.exports = {"fontTheme":"bankrate_fontTheme__8vDJ6"};